.workTitle {
    text-align: center;
    font-family: var(--font-serif);
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 1.5px;
    color: #937b70;
    font-weight: 600;
    margin-bottom: 25px;
    margin-top: 25px;
}

.workText {
    text-align: center;
    margin-bottom: 70px;
    color: #4a4a4a;
}

.cardContainer {
    display: flex;
    align-items: center;
    flex-direction: column;
}

.iconsContainer {
    width: 100%;
    height: 100%;
    top: 0;
    z-index: -1;
    position: absolute;
}